import React from "react";

const TwitterIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      fill="currentColor"
      viewBox="0 0 64 64"
      {...props}
    >
      <path d="M61.932 15.439a23.733 23.733 0 01-6.737 1.843 11.702 11.702 0 005.157-6.437 23.51 23.51 0 01-7.444 2.817A11.704 11.704 0 0044.366 10c-6.472 0-11.717 5.2-11.717 11.611 0 .907.106 1.791.306 2.649A33.39 33.39 0 018.807 12.119a11.47 11.47 0 00-1.586 5.847c0 4.031 2.064 7.579 5.211 9.67a11.926 11.926 0 01-5.312-1.45v.136c0 5.633 4.04 10.323 9.395 11.391-.979.268-2.013.417-3.079.417-.757 0-1.494-.086-2.208-.214 1.491 4.603 5.817 7.968 10.942 8.067a23.673 23.673 0 01-14.552 4.971c-.949 0-1.876-.054-2.793-.165A33.475 33.475 0 0022.786 56c21.549 0 33.337-17.696 33.337-33.047 0-.503-.016-1.004-.04-1.499a23.044 23.044 0 005.849-6.015"></path>
    </svg>
  );
};

export default TwitterIcon;
